import {Component} from '@angular/core';
import {Instancia} from "../../../../types/Instancia.type";
import {BuscanotafiscalService} from "../../../../services/buscanotafiscal.service";
import {BuscarNotaFiscal} from "../../../../types/BuscarNotaFiscal.type";
import {ToastService} from "../../../../services/toast.service";
import {ConfirmationService} from "primeng/api";
import {NotaFiscalLiberarImportacao} from "../../../../types/NotaFiscalLiberarImportacao.type";
import {FornecedorService} from "../../../../services/fornecedor.service";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-buscanotafiscal',
  templateUrl: './buscanotafiscal.component.html',
  styleUrl: './buscanotafiscal.component.css',
  providers: [ConfirmationService]
})
export class BuscanotafiscalComponent {
  datepipe: DatePipe = new DatePipe('pt-BR');

  notafiscal: string = "";
  loadingSincronizar: boolean = false;
  loadingRazaoSocial: boolean = false;
  loading: boolean = false;
  instanciaSelecionada: string = '';
  instancias: Instancia[] = [];
  notasfiscais: BuscarNotaFiscal[] = [];

  dataCompetencia!: Date;

  dataAtual: Date = new Date();

  constructor(private buscaNotaFiscalService: BuscanotafiscalService, private toastService: ToastService, private confirmationService: ConfirmationService, private fornecedorService: FornecedorService) {
  }


  buscarNotaFiscal() {

    this.loading = true;
    const datepipe: DatePipe = new DatePipe('pt-BR');
    console.log(this.dataAtual)

    this.buscaNotaFiscalService.getNotaFiscal(this.instanciaSelecionada, this.notafiscal, this.dataCompetencia.toLocaleDateString('pt-BR')).subscribe({
      next: (data) => {
        data.forEach(nota => {

          if (this.notaExistente(nota.instancia, nota.noNf, nota.serieNf, nota.dtCompetencia)) {
            this.toastService.alerta('Nota já carregada', `A nota fiscal ${nota.noNf}-${nota.serieNf} já consta na listagem`)
          } else {

            nota.cdFornecErpNova = nota.cdFornecErp
            nota.dtEmissaoNova = new Date()
            nota.deFornecErpNova = nota.deFornec

            if (nota.noNfErp != "0") {
              this.toastService.alerta('Nota já emitida', `A nota fiscal ${nota.noNf}-${nota.serieNf} já foi emitida, NF: ${nota.noNfErp}. Esta bloqueada para edição.`)
            } else {
              nota.noNfErp = "";
            }

            if (nota.deFornecErpNova.trim().length <= 0) {
              this.buscarRazaoSocial(nota);

              nota.deFornec = nota.deFornecErpNova
            }

            this.notasfiscais.push(nota);
          }

        })
      },
      error: (error) => {
        this.toastService.erro("Erro ao buscar", error.error)
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    })

  }

  private notaExistente(instancia: string, nota: string, serie: string, dataCompetencia: string): boolean {

    return this.notasfiscais.filter(nf => nf.instancia == instancia && nf.noNf == nota && nf.serieNf == serie && nf.dtCompetencia == dataCompetencia).length > 0;

  }

  removeNota(notafiscal: BuscarNotaFiscal) {

    this.confirmationService.confirm({
      message: `Tem certeza de que deseja remover a nota (${notafiscal.instancia}) ${notafiscal.noNf}-${notafiscal.serieNf}?`,
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.notasfiscais = this.notasfiscais.filter(nf => nf != notafiscal)
      }
    });

  }

  enviarNota(notafiscal: BuscarNotaFiscal) {


    let dataISO = null

    dataISO = this.datepipe.transform(notafiscal.dtEmissaoNova, 'yyyy-MM-dd') || null;

    this.confirmationService.confirm({
      message: `Por favor, revise os dados antes de confirmar:
                <br>
                <br><strong>Instância:</strong> ${notafiscal.instancia}
                <br><strong>NF:</strong> ${notafiscal.noNf}-${notafiscal.serieNf}
                <br><strong>Data Emissão:</strong> ${dataISO}
                <br><strong>Fornecedor:</strong> ${notafiscal.cdFornecErpNova}
                <br><br>
                <strong>A operação é irreversível.</strong>`,
      header: 'Confirmação da operação',
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      acceptLabel: 'Confirmar',
      rejectLabel: 'Cancelar',
      accept: () => {
        this.loading = true;

        if (dataISO != null) {

          let liberar: NotaFiscalLiberarImportacao = {
            instancia: notafiscal.instancia,
            dataCompetencia: notafiscal.dtCompetencia,
            nfPims: notafiscal.noNf,
            seriePims: notafiscal.serieNf,
            usuario: localStorage.getItem("cdUsuarioErp") || '',
            cdFornecErpAntiga: notafiscal.cdFornecErp,
            cdFornecErpNova: notafiscal.cdFornecErpNova,
            dataEmissaoAntiga: notafiscal.dtEmissao,
            dataEmissaoNova: dataISO,
            nfErp: notafiscal.noNfErp,
            codErpAntigo: notafiscal.cdFornecErp,
            razaoSocialAntiga: notafiscal.deFornec,
            cdFazenda: notafiscal.cdFazenda,
            deFazenda: notafiscal.deFazenda,
            razaoSocialNova: notafiscal.deFornecErpNova,
            valor: notafiscal.vlTotalNf
          }


        this.buscaNotaFiscalService.putAtualizaLiberaNotaFiscal(liberar).subscribe({
          next: (data) => {

          },
          error: (error) => {
            console.log(error)
            this.toastService.erro("Erro ao enviar", error.error.message)
            this.loading = false;
          },
          complete: () => {
            this.loading = false;
            this.toastService.sucesso("Sucesso", "Solicitação realizada com sucesso")
          }
        });
        }else{
          this.toastService.erro("Erro de data", "Data inválida, favor verificar o preenchimento.")
        }
      }
    });
  }

  buscarRazaoSocial(notafiscal: BuscarNotaFiscal) {

    this.loadingRazaoSocial = true;

    this.fornecedorService.getFornecedorSimplificado(notafiscal.cdFornecErpNova).subscribe({
      next: (data) => {
        notafiscal.deFornecErpNova = data.deFornec;
      },
      error: (error) => {
        this.loadingRazaoSocial = false;
        notafiscal.deFornecErpNova = ""
        this.toastService.erro("Erro ao buscar", error.error.message)
      },
      complete: () => {
        this.loadingRazaoSocial = false;
      }
    })
  }

  exportar(notafiscal?: BuscarNotaFiscal) {

    let notasExportar: NotaFiscalLiberarImportacao[] = [];

    if (notafiscal != undefined) {
      let dataISO = this.datepipe.transform(notafiscal.dtEmissaoNova, 'yyyy-MM-dd') || null;

      let liberar: NotaFiscalLiberarImportacao = {
        instancia: notafiscal.instancia,
        dataCompetencia: notafiscal.dtCompetencia,
        nfPims: notafiscal.noNf,
        seriePims: notafiscal.serieNf,
        usuario: localStorage.getItem("cdUsuarioErp") || '',
        cdFornecErpAntiga: notafiscal.cdFornecErp,
        cdFornecErpNova: notafiscal.cdFornecErpNova,
        dataEmissaoAntiga: notafiscal.dtEmissao,
        dataEmissaoNova: dataISO || "",
        nfErp: notafiscal.noNfErp,
        codErpAntigo: notafiscal.cdFornecErp,
        razaoSocialAntiga: notafiscal.deFornec,
        cdFazenda: notafiscal.cdFazenda,
        deFazenda: notafiscal.deFazenda,
        razaoSocialNova: notafiscal.deFornecErpNova,
        valor: notafiscal.vlTotalNf
      }

      notasExportar.push(liberar)
    } else {

      this.notasfiscais.forEach(notafiscal => {
        let dataISO = this.datepipe.transform(notafiscal.dtEmissaoNova, 'yyyy-MM-dd') || null;

        let liberar: NotaFiscalLiberarImportacao = {
          instancia: notafiscal.instancia,
          dataCompetencia: notafiscal.dtCompetencia,
          nfPims: notafiscal.noNf,
          seriePims: notafiscal.serieNf,
          usuario: localStorage.getItem("cdUsuarioErp") || '',
          cdFornecErpAntiga: notafiscal.cdFornecErp,
          cdFornecErpNova: notafiscal.cdFornecErpNova,
          dataEmissaoAntiga: notafiscal.dtEmissao,
          dataEmissaoNova: dataISO || "",
          nfErp: notafiscal.noNfErp,
          codErpAntigo: notafiscal.cdFornecErp,
          razaoSocialAntiga: notafiscal.deFornec,
          cdFazenda: notafiscal.cdFazenda,
          deFazenda: notafiscal.deFazenda,
          razaoSocialNova: notafiscal.deFornecErpNova,
          valor: notafiscal.vlTotalNf
        }

        notasExportar.push(liberar)
      })
    }

    this.loading = true;

    this.buscaNotaFiscalService.exportar(notasExportar).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a')
        a.href = url
        a.download = 'data.xlsx'
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.loading = false;
      },
      error: (error) => {
        this.toastService.erro("Erro ao exportar", error.error.message)
        this.loading = false;
      }
    })


  }

  protected readonly Date = Date;
}
